<div class="details">
  <app-loader #detailsLoader cssClasses="loader--white" />
  @if (data?.img) {
    <div class="details__thumbnail-wrapper">
      <img
        class="details__thumbnail"
        [src]="(data?.img | resizeImage: imageSizes.SIZE_640xAUTO | uncache | async ) ?? ''"
        />
    </div>
  } @else {
    <div
      class="details__no-image"
      [style.background-image]="'url(\'../../../assets/images/catalogue-list/no-article-image.svg\')'"
    ></div>
  }


  <div class="body-wrapper py-3 ps-3">
    <div class="details__body">
      <div class="details__body__title fw-bold text-center color-black text-break mh-100 pe-3">
        {{data?.title}}
      </div>

      @if (tag?.length) {
        <div class="text-center pt-2 pe-3">
          <span class="tag text-break d-inline-block color-gray-600">{{ tag }}</span>
        </div>
      }

      @if (data?.content) {
        <div class="w-100 details__body__content overflow-y-auto pt-3 small pe-3" [class.full-height]="fullHeight" [innerHtml]="data?.content"></div>
      }
    </div>
  </div>
</div>
